import gql from "graphql-tag";

export const MY_TAX_GET_THREE_CHILDREN_DECLARATION = gql`
  query taxDeclarationThreeChildren($_id: Int!) {
    taxDeclarationThreeChildren(_id: $_id) {
      dateOfDeclaration
      isModifiedDeclaration
      state
      isEligible
      isEligibleTwo
      isEligibleThree
      permanentlyEntitled
      notApplyFromMonth
      dependents {
        dependentSerialNumber
        name
        taxNumber
        placeOfBirth
        dateOfBirth
        mothersName
      }
    }
  }
`;
